import type { OfferType } from '@makemydeal/dr-platform-types';
import { CASH, FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import type { PartialPenciledInputsWithAllTypes, PenciledInputsState } from '../../../types/commonTypes';
import * as types from '../../../types/actionTypes';
import { updateInputWithValue, updateOfferPrice, updateOfferTypeWithInputs } from '../helpers';

export const handlePriceUpdateCases = (
    state: PenciledInputsState,
    action: any,
    offerType: OfferType
): PartialPenciledInputsWithAllTypes => {
    switch (action.type) {
        case types.UPDATED_FINANCE_OFFER_PRICE: {
            const financeOfferPrice = action.payload;
            const inputs = updateInputWithValue(state.byOfferType?.[FINANCE], 'offerPrice', financeOfferPrice);
            const byOfferType = updateOfferTypeWithInputs(state.byOfferType, inputs, FINANCE);
            return {
                ...state,
                byOfferType
            };
        }

        case types.UPDATED_FINANCE_AND_LEASE_OFFER_PRICE: {
            const price = action.payload;
            return {
                ...state,
                byOfferType: updateOfferPrice(state.byOfferType, price, [FINANCE, LEASE])
            };
        }

        case types.UPDATED_FINANCE_AND_CASH_OFFER_PRICE: {
            const cashAndFinancePrice = action.payload;
            return {
                ...state,
                byOfferType: updateOfferPrice(state.byOfferType, cashAndFinancePrice, [FINANCE, CASH])
            };
        }

        case types.UPDATED_FINANCE_AND_LEASE_AND_CASH_OFFER_PRICE: {
            const allPrice = action.payload;
            return {
                ...state,
                byOfferType: updateOfferPrice(state.byOfferType, allPrice, [FINANCE, LEASE, CASH])
            };
        }

        case types.UPDATED_OFFER_PRICE_IMMEDIATE: {
            const offerPrice = action.payload;
            const inputs = updateInputWithValue(state.byOfferType?.[offerType], 'offerPrice', offerPrice);
            const offerImmediate = updateOfferTypeWithInputs(state.byOfferType, inputs, offerType);

            return {
                ...state,
                byOfferType: offerImmediate
            };
        }

        default: {
            return state;
        }
    }
};
